import { Controller, Menu, Toolbar } from '@tencent/workbench';
import { MutiPictureExportFeature } from './muti-picture-export-feature';
import { INSERT_TEXT_MENU_CONFIGS, TOOLBAR_ITEMS, config } from './config';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { wrapIdForBig, wrapIdForVip } from '@src/framework/workbench/util/wrap-id-util';
import { CLICK_FROM } from '../../constant';
import ua from '@tencent/docs-user-agent';

@Controller({
    menuItems: INSERT_TEXT_MENU_CONFIGS,
    toolbarItems: TOOLBAR_ITEMS,
})
export class MutiPictureExportController {
    public constructor(private readonly feature: MutiPictureExportFeature) {
    }

    @Menu(config.id, 'onClick')
    @Toolbar(wrapIdForBig(config.id), 'onClick', { clickFrom: CLICK_FROM.TOOLBAR })
    @Toolbar(wrapIdForVip(config.id), 'onClick', { clickFrom: CLICK_FROM.TOOLBAR })
    public onClick() {
        this.feature.getAppService()
            .editableServiceLayer?.quickToolDialogManager.promise().then((quickToolDialogManager) => {
                quickToolDialogManager.showDialog(ActionType.MUTI_PICTURE_EXPORT);
            });
    }

    @Menu(config.id, 'shouldHide')
    @Toolbar(wrapIdForBig(config.id), 'shouldHide')
    @Toolbar(wrapIdForVip(config.id), 'shouldHide')
    public shouldExportImageHide(): boolean {
        return ua.isWxMiniProgram || ENV.IS_PC_LOCAL_EDIT;
    }

    @Toolbar(wrapIdForBig(config.id), 'shouldDisabled')
    @Toolbar(wrapIdForVip(config.id), 'shouldDisabled')
    public shouldDisabled(): boolean {
        return this.feature.shouldDisabled(config.id);
    }
}
